// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1XNM1","title":"Images45_title__3rEFI","images":"Images45_images__37La9"};